'use strict';

var Sugar = require('sugar-core');

require('./build/buildRelativeAliasesCall');

module.exports = Sugar.Date.isToday;


//////////////////
// WEBPACK FOOTER
// ./~/sugar-date/date/isToday.js
// module id = 322
// module chunks = 0